const cellDimensionsRatio = 1.3;
const minDimLength = 100;
const maxDimLength = 200;

function getResizedSecondaryDimension(primaryDimension) {
  const secondaryDim = primaryDimension / cellDimensionsRatio;
  if (minDimLength > secondaryDim) {
    return minDimLength;
  }
  if (maxDimLength < secondaryDim) {
    return maxDimLength;
  }
  return secondaryDim;
}

export function getResizedRowWithStructureHeight(headerWidth) {
  return getResizedSecondaryDimension(headerWidth);
}

export function getResizedColumnWithStructureWidth(headerHeight, currentColumnWidth) {
  // if columns header is already stretched horizontally to fill heatmap area
  if (currentColumnWidth > maxDimLength) {
    return currentColumnWidth;
  }
  return getResizedSecondaryDimension(headerHeight);
}
